//Done
import React, {useState, useEffect} from 'react';
import { Table, Button, Popconfirm, Space, Row, Col, Select,} from 'antd';
import CourseModal from './CourseModal';
import { SearchOutlined } from '@ant-design/icons';

  
export default function CourseTable () {
  const [modalVisible, setModalVisible] = useState(false);
  const [dataIsLoading, setDataIsLoading] = useState(false);
  const [gradeDataSource, setGradeDataSource] = useState([]);
  const [semesterDataSource, setSemesterDataSource] = useState([]);
  const [courseDataSource, setCourseDataSource] = useState([]);
  const [modalRowRecord, setModalRowRecord] = useState(null);
  const [modalIsEditing, setModalIsEditing] = useState(null);
  const [selectedGrade, setSelectedGrade] = useState('');
  const [selectedSemester, setSelectedSemester] = useState('');

  const {Option} = Select;


const handleAdd = () => {
  setModalIsEditing(false);
  setModalVisible(true)    
};


//=====================================Done 华丽的分割线==============================================================
  const columns = [
    {
      title: 'Courses',
      dataIndex: 'title',
      width: '80%',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => {
        let nameA = a.title.toUpperCase();
        let nameB = b.title.toUpperCase();
        if (nameA < nameB) {
          return -1;
        } else if (nameA > nameB) {
          return 1;
        } else {
          if (nameA.length < nameB.length) {
            return -1;
          } else {
            return 1
          }
        }
      },
    },
    {
      title: 'Operation',
      dataIndex: 'operation',
      render: (text, record) => ( 
        <Space size="middle">
          <Button type="text" onClick={() => {handleEditClicked(record)}} className="opBtn" style={{color: "blue"}}>Edit</Button>
          <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record)}>
            <Button danger type="text">Delete</Button>
          </Popconfirm>
        </Space>
      )
    },
  ];

  const onCreate = (values) => {      
    const newData = {
      gradeId: values.grade,
      semesterId: values.semester,
      title: values.title,
    }
    let checkDuplicate = [];
    courseDataSource.map(x => {
      const newStr = x.title.split(" ").join("").toLowerCase();
      checkDuplicate.push(newStr);
      return checkDuplicate;
    })
    const newInputStr = newData.title.split(" ").join("").toLowerCase();
    const index = checkDuplicate.findIndex(x => x === newInputStr);
    if (index !== -1) {
      alert('This course has already exist!');
      setModalVisible(false);
    } else {
      setDataIsLoading(true);
      fetch('https://kh-studentrecordsystem.herokuapp.com/coursesInfo', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(newData),
      })
        .then(response => response.json())
        .then(data => {
          fetch('https://kh-studentrecordsystem.herokuapp.com/coursesInfo')
            .then(res => res.json())
            .then(data => {
              setCourseDataSource(data);
              setModalVisible(false);
              setDataIsLoading(false)
            })   
            .catch((error) => {console.error('Error:', error);});         
        })
        .catch((error) => {console.error('Error:', error);});
    }
  };

  const handleEditClicked = (record) => {
    setModalIsEditing(true);
    setModalRowRecord(record);
    setModalVisible(true);
  }

  const handleModalUpdate = (values) => {
    const newData = {
      _id: modalRowRecord._id,
      title: values.title
    }
    setDataIsLoading(true);
    fetch('https://kh-studentrecordsystem.herokuapp.com/coursesInfo', {
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(newData),
    })
      .then(data => {
        if (!selectedSemester || !selectedSemester) {
          fetch(`https://kh-studentrecordsystem.herokuapp.com/coursesInfo`)
            .then(response => response.json())
            .then(data => {setCourseDataSource(data)})
            .catch(err => console.log(err))
        } else {
          fetch(`https://kh-studentrecordsystem.herokuapp.com/coursesInfo/grade/${selectedGrade}/semester/${selectedSemester}`)
            .then(response => response.json())
            .then(data => {setCourseDataSource(data)})
            .catch(err => console.log(err))
        }
      })
      .then(data => {
        setDataIsLoading(false);
        setModalVisible(false);
      })
      .catch(err => console.log(err))
  }

  const handleDelete = (record) => {
    setDataIsLoading(true);
    fetch('https://kh-studentrecordsystem.herokuapp.com/coursesInfo', {
      method: 'DELETE',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(record),
    })
      .then(response => {
        if (!response.ok) {
          throw response
        }
        return response.json()
      })
      .then(data => {
        fetch(`https://kh-studentrecordsystem.herokuapp.com/coursesInfo`)
            .then(response => response.json())
            .then(data => {
              setCourseDataSource(data);
              setDataIsLoading(false);
            })
            .catch(err => console.log(err))
      })
//返回Error Message的新写法，能输出给前端，需记
      .catch(err => {
        err.text()
          .then(errorMessage => {
            alert(errorMessage);
            setDataIsLoading(false);
          })
      })
  };

  const handleSearch = () => {
    if (selectedGrade && selectedSemester) {
      fetch(`https://kh-studentrecordsystem.herokuapp.com/coursesInfo/grade/${selectedGrade}/semester/${selectedSemester}`)
        .then(response => response.json())
        .then(data => {setCourseDataSource(data)})
        .catch(err => console.log(err))
    } else {
      alert('Please select Grade and Semester for searching!')
    }
  }

  useEffect(() => {
    fetch('https://kh-studentrecordsystem.herokuapp.com/gradesInfo')
          .then(response => response.json())
          .then(data => {setGradeDataSource(data.Data)})
          .catch(err => console.log(err));
    fetch('https://kh-studentrecordsystem.herokuapp.com/semestersInfo')
        .then(response => response.json())
        .then(data => {setSemesterDataSource(data)})
        .catch(err => console.log(err)); 
    fetch('https://kh-studentrecordsystem.herokuapp.com/coursesInfo')     
        .then(response => response.json())
        .then(data => {setCourseDataSource(data)})
        .catch(err => console.log(err)); 
  }, [])

  




//=====================================最终的Return 华丽的分割线==============================================================
  return (
    <div>
      <Row justify="center">
        <Col xs={23} lg={{span: 22, offset: 1}} xl={{span: 22, offset: 3}}>     
          <div>
            <Button onClick={handleAdd} type="primary" className="pageMainFuncBtn">Add New Course</Button>

            <CourseModal
              gradeDataSource={gradeDataSource}
              semesterDataSource={semesterDataSource}
              modalIsEditing={modalIsEditing}
              visible={modalVisible}
              record={modalRowRecord}
              onCreate={onCreate}
              onUpdate={handleModalUpdate}
              onCancel={() => {
                setModalRowRecord(null)
                setModalVisible(false);
              }}
            />
          </div>
        </Col>
      </Row>

      <Row justify="center">
        <Col xs={23} lg={{span: 22, offset: 1}} xl={{span: 22, offset: 3}}>
          <Select 
            placeholder="--Select Grade--" 
            allowClear
            onChange={(value) => setSelectedGrade(value)}
            style={{marginRight: "21px", width: "228px", marginBottom: "21px"}}
          >
            {gradeDataSource.map(x => (
              <Option key={x._id}>{`Grade ${x.grade}`}</Option>
            ))}
          </Select>

          <Select 
            placeholder="--Select Semester--" 
            allowClear
            onChange={(value) => setSelectedSemester(value)}
            style={{marginRight: "21px", width: "228px"}}
          >
            {semesterDataSource.map(x => (
              <Option key={x._id}>{`Semester ${x.semester}`}</Option>
            ))}
          </Select>

          <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch} style={{width: "128px"}}>
            Search
          </Button>
        </Col>
      </Row>            

      <Row justify="center">
        <Col xs={23} lg={{span: 22, offset: 1}} xl={{span: 22, offset: 3}}>                    
          <Table
            rowKey={record => record._id}
            bordered
            dataSource={courseDataSource}
            columns={columns}
            pagination={{defaultPageSize: 20}}
            loading={dataIsLoading}
          />
        </Col>
      </Row>
    </div>
  );
};